import React from 'react';
import { Card, Flex, Typography, theme } from 'antd';
import { CheckCircleTwoTone } from '@ant-design/icons';

type Props = {
  title: string;
  items: string[];
  fullWidth?: boolean;
};

function SearchPerformanceInfoPanel({ title, items, fullWidth = false }: Props) {
  const { token } = theme.useToken();

  return (
    <Card
      variant="borderless"
      style={{
        width: fullWidth ? '100%' : 400 /* FIXME: no exact token */,
        background: token.colorFillAlter,
        flexShrink: fullWidth ? undefined : 0,
      }}
      styles={{ body: { padding: token.padding } }}
    >
      <Flex vertical gap={token.padding}>
        <Typography.Title level={5} type="secondary" style={{ margin: 0 }}>
          {title}
        </Typography.Title>
        <Flex vertical gap={token.marginLG}>
          {items.map((item) => (
            <Flex key={item} gap={token.marginXS} align="flex-start">
              <CheckCircleTwoTone twoToneColor={token.colorPrimary} style={{ fontSize: token.fontSizeLG, marginTop: token.marginXXS, flexShrink: 0 }} />
              <Typography.Text type="secondary" style={{ fontSize: token.fontSizeLG, lineHeight: token.lineHeightLG }}>
                {item}
              </Typography.Text>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Card>
  );
}

export default SearchPerformanceInfoPanel;
